<!-- Hero Section -->
<section
  class="bg-[url('/assets/images/Model3_53.webp')] bg-cover bg-center bg-blend-multiply bg-black/50 min-h-[50vh] lg:min-h-[40vh] flex flex-col justify-center items-center text-white px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="2xl:w-[70%]">
    <h1 class="text-3xl lg:text-5xl font-extrabold text-center mb-">
      ONLY USED TESLA: The Premier Platform for Dealerships to advertise their
      used tesla for sale inventory.
    </h1>
  </div>
</section>

<section class="py-10 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div
    class="container mx-auto flex flex-col-reverse lg:flex-row items-center gap-5 xl:gap-10"
  >
    <div class="basis-[50%]">
      <h2 class="font-semibold text-xl lg:text-3xl">
        Why Choose Only Used Tesla For Your "Used Tesla For Sale" Inventory?
      </h2>
      <p>
        Every dealership seeks to maximize exposure for their inventory. But
        when it comes to selling a brand as unique and sought-after as Tesla,
        specialized exposure matters.
      </p>
    </div>
    <div class="basis-[50%]">
      <img src="/assets/images/OUT-tesla-16.jpg" class="rounded" alt="" />
    </div>
  </div>
</section>

<section class="py-10 px-3 md:px-5 2xl:px-28 3xl:px-52 bg-gray-100">
  <div class="container mx-auto flex flex-col lg:flex-row items-center gap-5 xl:gap-10">
    <div class="basis-[50%]">
      <img src="/assets/images/OUT-tesla-10.jpg" class="rounded" alt="" />
    </div>
    <div class="basis-[50%] space-y-2">
      <h2 class="font-semibold text-xl lg:text-2xl">
        We rank #4 for the keyword “Used Tesla for Sale.” If you’re a dealer
        with used Tesla inventory, we can help you get visibility on your
        listings.
      </h2>
      <p>We offer a range of services to boost your inventory:</p>
      <ul class="space-y-1.5 list-inside">
        <li class="flex items-center gap-2">
          <img src="/assets/images/checkmark.svg" alt="checkmark" />SEO to rank
          your listings in your state
        </li>
        <li class="flex items-center gap-2">
          <img src="/assets/images/checkmark.svg" alt="checkmark" />Paid Ads
        </li>
        <li class="flex items-center gap-2">
          <img src="/assets/images/checkmark.svg" alt="checkmark" />Google PPC &
          Vehicle Ads
        </li>
        <li class="flex items-center gap-2">
          <img src="/assets/images/checkmark.svg" alt="checkmark" />Facebook &
          YouTube HD Ads
        </li>
      </ul>
      <p class="">
        Plus, we source Tesla inventory from private sellers for your dealership
        with our cash offer service. We’ve been in the Tesla market since 2017
        and know how to drive results. Join us for just $500/month. Let’s get
        your Teslas seen today!
      </p>
      <div class="mt-3">
        <a
          routerLink="/contact"
          class="text-white bg-OUT-Blue rounded-full px-5 py-2 border-[2px] font-semibold cursor-pointer"
        >
          Contact us now!
        </a>
      </div>
    </div>
  </div>
</section>

<section class="py-10 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div
    class="container mx-auto flex flex-col-reverse lg:flex-row justify-center items-center gap-5 xl:gap-10"
  >
    <div class="basis-[50%] space-y-2">
      <h2 class="font-semibold text-xl lg:text-2xl">
        Here's why partnering with Only Used Tesla is the smart move for your
        dealership:
      </h2>
      <ul class="list-disc space-y-2 ps-5">
        <li class="text-OUT-Blue">
          <p class="text-gray-700">
            <strong>Tailored Audience Since 2017:</strong> Dive into a community
            of avid Tesla enthusiasts and buyers who trust our platform for
            their purchase. With years in the game, we understand the Tesla
            market better than anyone else.
          </p>
        </li>

        <li class="text-OUT-Blue">
          <p class="text-gray-700">
            <strong>Concentrated Buyer Exposure:</strong> By focusing solely on
            Teslas, your inventory gets spotlighted in front of an audience with
            serious buying intent.
          </p>
        </li>

        <li class="text-OUT-Blue">
          <p class="text-gray-700">
            <strong>Extensive Social Media Exposure:</strong> We don't just
            list. We amplify! Get your "used Tesla for sale" inventory showcased
            on our thriving Reddit, Twitter, and Facebook communities. Plus,
            enjoy visibility on our new YouTube channel with 350+ video ads – a
            feature not many offer.
          </p>
        </li>

        <li class="text-OUT-Blue">
          <p class="text-gray-700">
            <strong>Accurate and Effective Listings:</strong> Say goodbye to the
            errors. Our team verifies and labels your Vehicle Detail Page (VDP)
            with precise information.
          </p>
        </li>

        <li class="text-OUT-Blue">
          <p class="text-gray-700">
            <strong>SEO-Driven Ad Copy:</strong> Say goodbye to the errors. Our
            team verifies and labels your Vehicle Detail Page (VDP) with precise
            information.
          </p>
        </li>

        <li class="text-OUT-Blue">
          <p class="text-gray-700">
            <strong>Smooth Integration:</strong> We're compatible with popular
            feed exporters like Dealer Center, vAuto, and HomeNet. And we're
            continuously evolving our platform to serve you better.
          </p>
        </li>
      </ul>
    </div>
    <div class="basis-[50%] w-full h-[65vh]">
      <img
        src="/assets/images/OUT-tesla-15.jpg"
        class="rounded w-full h-full object-cover object-top"
        alt=""
      />
    </div>
  </div>
</section>

<section
  class="text-center text-white bg-[url('/assets/images/ModelS_94.webp')] bg-black/75 bg-cover bg-center bg-blend-multiply py-10 2xl:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <div class="flex flex-col justify-center items-center">
    <h2 class="text-xl lg:text-3xl font-bold">
      Ready to Amplify Your "Sell My Tesla" Game?
    </h2>
    <p class="lg:text-lg text-gray-70 mt-4 2xl:w-[70%]">
      If you're a dealer with a <strong>"used Tesla for sale"</strong> inventory
      and are looking to elevate your marketing strategy, it's time to connect
      with the leaders in the Tesla resale market.
    </p>
    <a
      routerLink="/contact"
      class="my-4 inline-block bg-OUT-Blue text-white font-semibold py-2 px-6 rounded-full hover:bg-OUT-Blue/80 transition-colors duration-300 w-fit cursor-pointer"
    >
      Get In Touch With Us Now
    </a>
    <p>
      Thank you for considering Only Used Tesla, where our mission is to connect
      quality Teslas with passionate buyers.
    </p>
    <p class="mt-6 mb- italic">Warm Regards,</p>
    <p class="text-gray-00 font-semibold">The Only Used Tesla Team</p>
  </div>
</section>
